export const en = {
    nav: {
        templates: 'Templates',
        insights: 'Insights',
        cloneable: 'Cloneable',
        faq: 'FAQ',
        contact: 'Contact',
        allAccess: 'All-Access 95% Off',
        store: 'Store',
        moreStuff: 'More Awesome Stuff',
        topBanner: '95% OFF in ALL Templates',
        notification: '1 FREE Webflow template on every 2 purchases – Claim yours now! 💙🎉😍'
    },
    home: {
        badgeOff: '95% OFF',
        badgePages: '1,300+ Unique Pages',
        heroTitle: 'Build Sites Fast. Save Big',
        heroSubtitle: 'Get daily access to hundreds of premium Webflow templates — pay once, build many sites.',
        heroCta: 'Unlock All – 95% OFF',
        allAccessTitle: 'All-Access Pass',
        allAccessLead: 'Get all-access for the',
        allAccessLeadStrong: 'full library for the price of 1 template',
        allAccessMid: 'boost your productivity with instant access to all',
        allAccessStrong2: '216 templates',
        allAccessTail: 'and monthly new releases.',
        allAccessCta: 'Unlock All-Access',
        categories: 'Categories',
        tags: 'Tags',
        allCategories: 'All categories',
        allTags: 'All tags',
        searchCategories: 'Search categories…',
        searchTags: 'Search tags…',
        noResults: 'No results found.',
        subscribeToDownload: 'Subscribe to Download',
        previous: 'Previous',
        next: 'Next',
        noItems: 'No items found.',
        loadMore: 'Load more',
        emptyTitle: 'No templates match these filters',
        emptyBody: 'Try removing a filter or widening your search — or browse the full library to find your perfect Webflow template.',
        clearFilters: 'Clear filters',
        browseAll: 'Browse all templates'
    },
    footer: {
        tagline: 'We create Webflow template that perform & convert.',
        product: 'Product',
        unlockAllAccess: 'Unlock All-Access',
        templates: 'Templates',
        ourFlow: 'Our Flow',
        insights: 'Insights',
        giveaway: "Sep '23 Giveaway 🎉",
        cloneable: 'Cloneable',
        tags: 'Tags',
        affiliate: 'Affiliate',
        other: 'Other',
        contact: 'Contact',
        privacy: 'Privacy Policy',
        faq: 'FAQ',
        followUs: 'Follow us',
        topCategories: 'Top Categories',
        topTags: 'Top #Tags',
        mission: 'Our mission is enabling the magic of coding without learning to code.',
        emailPlaceholder: 'Email Address',
        subscribe: 'Subscribe',
        subscribeSuccess: 'Thanks! Check your inbox to confirm.',
        subscribeError: 'Something went wrong. Please try again.'
    },
    templateDetail: {
        otherTemplates: 'Other',
        otherTemplatesAccent: 'webflow',
        otherTemplatesTail: 'templates',
        webflow: 'Webflow',
        templateWord: 'Template',
        buyOnWebflow: 'Buy on Webflow',
        getThisMore: 'Get this +215 more for $69',
        orPreviewIn: 'Or Preview in',
        browser: 'Browser',
        designer: 'Designer'
    },
    testimonials: {
        heading: 'People like what',
        headingAccent: 'we do'
    },
    blog: {
        readBlogPost: 'Read blog post',
        insightsAccent: 'Insights',
        fromWord: 'from',
        categoryWord: 'category',
        otherInsights: 'Other',
        otherInsightsAccent: 'Insights',
        mostRead: 'Most read articles:',
        author: 'Author:',
        published: 'Published',
        updated: 'Updated',
        categoryLabel: 'Category',
        share: 'Share',
        subscribeInspo: 'Subscribe to Wedoflow Inspo'
    },
    contact: {
        title: 'Need help with your site?',
        subtitle: 'Ask questions, share your work, or chat with our team, just drop a text.',
        startConversation: 'Start the conversation',
        getInTouch: 'Get in touch with us',
        emailPlaceholder: 'Your Email',
        companyPlaceholder: 'Company Name',
        messagePlaceholder: 'Message',
        submit: 'Submit',
        sending: 'Please wait...',
        success: 'Thank you! Your submission has been received!',
        error: 'Oops! Something went wrong while submitting the form.'
    },
    marketplace: {
        otherTemplates: 'Other Webflow',
        otherTemplatesAccent: 'templates'
    },
    common: {
        loading: 'Loading…',
        backToHome: 'Back to home',
        readMore: 'Read more',
        viewTemplate: 'View Template',
        from: 'From',
        notFoundTitle: 'Page not found',
        notFoundText: "The page you are looking for doesn't exist or has moved."
    }
}

export type Dictionary = typeof en
